// source: pbtypes/gen/skills/standard_tracking_control_scheme_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skills.StandardTrackingControlSchemeParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.StandardTrackingControlSchemeParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.StandardTrackingControlSchemeParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.StandardTrackingControlSchemeParams.displayName = 'proto.skills.StandardTrackingControlSchemeParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.StandardTrackingControlSchemeParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.StandardTrackingControlSchemeParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.StandardTrackingControlSchemeParams.toObject = function(includeInstance, msg) {
  var f, obj = {
azimuthRateMax: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
azimuthRateSlewRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
rangeSlewRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
elevationSlewRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
heightSlewRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
minSpanRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
maxSpanRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.StandardTrackingControlSchemeParams}
 */
proto.skills.StandardTrackingControlSchemeParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.StandardTrackingControlSchemeParams;
  return proto.skills.StandardTrackingControlSchemeParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.StandardTrackingControlSchemeParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.StandardTrackingControlSchemeParams}
 */
proto.skills.StandardTrackingControlSchemeParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAzimuthRateMax(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAzimuthRateSlewRate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRangeSlewRate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setElevationSlewRate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeightSlewRate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinSpanRatio(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxSpanRatio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.StandardTrackingControlSchemeParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.StandardTrackingControlSchemeParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.StandardTrackingControlSchemeParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAzimuthRateMax();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getAzimuthRateSlewRate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getRangeSlewRate();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getElevationSlewRate();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getHeightSlewRate();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMinSpanRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getMaxSpanRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
};


/**
 * optional double azimuth_rate_max = 1;
 * @return {number}
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.getAzimuthRateMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StandardTrackingControlSchemeParams} returns this
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.setAzimuthRateMax = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double azimuth_rate_slew_rate = 2;
 * @return {number}
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.getAzimuthRateSlewRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StandardTrackingControlSchemeParams} returns this
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.setAzimuthRateSlewRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double range_slew_rate = 3;
 * @return {number}
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.getRangeSlewRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StandardTrackingControlSchemeParams} returns this
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.setRangeSlewRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double elevation_slew_rate = 4;
 * @return {number}
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.getElevationSlewRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StandardTrackingControlSchemeParams} returns this
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.setElevationSlewRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double height_slew_rate = 5;
 * @return {number}
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.getHeightSlewRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StandardTrackingControlSchemeParams} returns this
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.setHeightSlewRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double min_span_ratio = 6;
 * @return {number}
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.getMinSpanRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StandardTrackingControlSchemeParams} returns this
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.setMinSpanRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double max_span_ratio = 7;
 * @return {number}
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.getMaxSpanRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StandardTrackingControlSchemeParams} returns this
 */
proto.skills.StandardTrackingControlSchemeParams.prototype.setMaxSpanRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


goog.object.extend(exports, proto.skills);
